"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _jwt = require("../../modules/jwt");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*eslint-disable react/no-string-refs*/
var JwtRefresher = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(JwtRefresher, _React$Component);
  var _super = _createSuper(JwtRefresher);
  function JwtRefresher(props, context) {
    (0, _classCallCheck2.default)(this, JwtRefresher);
    return _super.call(this, props, context);
  }
  (0, _createClass2.default)(JwtRefresher, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.jwtKeepAlivePinger) {
        window.clearTimeout(this.jwtKeepAlivePinger);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$JWT = prevProps.JWT;
      _prevProps$JWT = _prevProps$JWT === void 0 ? {} : _prevProps$JWT;
      var prevJWTExpiresTS = _prevProps$JWT.JWTExpiresTS;
      var _this$props$JWT = this.props.JWT;
      _this$props$JWT = _this$props$JWT === void 0 ? {} : _this$props$JWT;
      var currJWTExpiresTS = _this$props$JWT.JWTExpiresTS;
      if (prevJWTExpiresTS !== currJWTExpiresTS) {
        this.setJwtKeepAlivePinger(currJWTExpiresTS);
      }
    }
  }, {
    key: "jwtKeepAlivePing",
    value: function jwtKeepAlivePing() {
      if (this.jwtKeepAlivePinger) {
        window.clearTimeout(this.jwtKeepAlivePinger);
      }
      this.props.doJwtRefresh();
    }
  }, {
    key: "setJwtKeepAlivePinger",
    value: function setJwtKeepAlivePinger() {
      var _this = this;
      var nextJWTExpiresTS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _this$props = this.props,
        enabled = _this$props.enabled,
        _this$props$JWT2 = _this$props.JWT;
      _this$props$JWT2 = _this$props$JWT2 === void 0 ? {} : _this$props$JWT2;
      var _this$props$JWT2$JWTE = _this$props$JWT2.JWTExpiresTS,
        JWTExpiresTS = _this$props$JWT2$JWTE === void 0 ? 0 : _this$props$JWT2$JWTE;

      // no JWT - no timer, session less - no timer
      if (!enabled) {
        return;
      }

      // if we didn't get nextJWTExpiresTS value - we attempt to use one currently in props
      if (!nextJWTExpiresTS) {
        nextJWTExpiresTS = JWTExpiresTS;
      }
      var timeRemaining = Math.max(nextJWTExpiresTS * 1000 - Date.now() - 120000, nextJWTExpiresTS === 0 ? 0 : 10000);
      this.jwtKeepAlivePinger = window.setTimeout(function () {
        _this.jwtKeepAlivePing();
        // two minutes before session is dead do a KeepAlive ping
      }, timeRemaining);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setJwtKeepAlivePinger();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return JwtRefresher;
}(_react.default.Component);
var _default = exports.default = (0, _reactRedux.connect)(function (_ref) {
  var isLoggedIn = _ref.userPrefs.isLoggedIn,
    JWT = _ref.JWT;
  return {
    enabled: isLoggedIn,
    JWT: JWT
  };
}, {
  doJwtRefresh: _jwt.doJwtRefresh
})(JwtRefresher);